export enum TreatmentRequestLog {
  RequestPageIn = 'request_page_in',
  RequestPageInWithTargetDate = 'request_page_in_with_target_date',
  RequestPageInWithoutTargetDate = 'request_page_in_without_target_date',
  RequestClickBookingTime = 'request_click_booking_time',
  RequestSuccessSsn = 'request_success_ssn',
  RequestMoveToPaymentStep = 'request_move_to_payment_step',
  RequestClickNonBenefitCategory = 'request_click_non_benefit_category',
  RequestOpenNonBenefitCategory = 'request_open_non_benefit_category',
  RequestUploadImage = 'request_upload_image',
  RequestPrevStepFromDiagnosis = 'request_prev_step_from_diagnosis',
  RequestPrevStepFromPayment = 'request_prev_step_from_payment',
  RequestClickContinueInModal = 'request_click_continue_in_modal',
  RequestClickStopInModal = 'request_click_stop_in_modal',
  RequestClickAutoAgreementCheck = 'request_click_auto_agreement_check',
  RequestSubmitClick = 'request_submit_click',
  RequestManualOpenCategory = 'request_manual_open_category',
  RequestAutoOpenCategory = 'request_auto_open_category',
  RequestSelectCategory = 'request_select_category',
  RequestPageInQuickMatch = 'request_page_in_quick_match',
  RequestOpenLoadDetailSymptoms = 'request_open_load_detail_symptoms',
  RequestSelectLoadDetailSymptom = 'request_select_load_detail_symptom',
  ImpressedChildInfoSection = 'impressed_child_info_section',
}

export enum EWebTreatmentRequestLog {
  CategorySelectItemClick = 'category_select_item_click',
  RequestStepChangeToDiagnosis = 'web_request_step_change_to_diagnosis',
  RequestStepChangeToDoctor = 'web_request_step_change_to_doctor',
  RequestStepChangeToPayment = 'web_request_step_change_to_payment',
  RequestStepChangeToCertificationGuide = 'web_request_step_change_to_certification_guide',
  ClickNextToDoctor = 'click_next_to_doctor',
  ClickCompleteButton = 'click_complete_button',
  ClickTelemedicineRequestInDoctorDetail = 'click_telemedicine_request_in_doctor_detail',
  OpenDoctorDetail = 'open_doctor_detail',
  CloseDoctorDetail = 'close_doctor_detail',
  ClickSelectCardCompany = 'click_select_card_company',
  ClickSelectCard = 'click_select_card',
  ClickAddCreditCard = 'click_add_credit_card',
  ClickAddKakaoPay = 'click_add_kakao_pay',
  ClickOpenInstallment = 'click_open_installment',
  ClickTogglePoint = 'click_toggle_point',
  ClickAgreement = 'click_agreement',
  ClickAllAgreement = 'click_all_agreement',
  ClickAgreementLink = 'click_agreement_link',
  ClickSubmitDiagnosis = 'click_submit_diagnosis',
  ClickCtaButton = 'click_cta_button',
  ClickIdvSheet = 'click_idv_sheet',
  ClickCloseButton = 'click_close_button',
  ClickDoctorPro = 'click_doctor_pro',
  ClickDoctorSort = 'click_doctor_sort',
  ClickReqDoctorSelect = 'click_req_doctor_select',
  ClickRequestTime = 'click_request_time',
  ClickRequestTypeOpen = 'click_request_type_open',
  ClickIdvSheetClose = 'click_idv_sheet_close',
  ClickWebDiagnosisToRequest = 'click_web_diagnosis_to_request',
  ClickWebDiagnosisToCategories = 'click_web_diagnosis_to_categories',
  ClickQuickScheduleMode = 'click_quick_schedule_mode',
  ClickGeneralScheduleMode = 'click_general_schedule_mode',
}

export const logs: Record<TreatmentRequestLog, string> = {
  request_page_in: '진료신청서 진료신청 페이지 진입',
  request_page_in_with_target_date: '진료신청서 진료신청 페이지 진입(예약 날짜 선택)',
  request_page_in_without_target_date: '진료신청서 진료신청 페이지 진입(예약 날짜 미선택)',
  request_click_auto_agreement_check: '진료신청서 자동 동의 체크 클릭',
  request_click_booking_time: '진료신청서 예약 시간 클릭',
  request_click_continue_in_modal: '진료신청서 이탈 모달 내 계속 작성 클릭',
  request_click_stop_in_modal: '진료신청서 이탈 모달 내 그만두기 클릭',
  request_click_non_benefit_category: '진료신청서 내 비급여 카테고리 클릭',
  request_open_non_benefit_category: '진료신청서 내 비급여 카테고리 오픈',
  request_submit_click: '진료신청서 진료 신청',
  request_move_to_payment_step: '진료신청서 결제 단계로 이동',
  request_prev_step_from_diagnosis: '진료신청서 진료신청 단계에서 이전으로 이동',
  request_prev_step_from_payment: '진료신청서 결제 단계에서 이전으로 이동',
  request_success_ssn: '진료신청서 주민번호 입력 완료',
  request_upload_image: '진료신청서 사진 업로드',
  request_manual_open_category: '진료신청서 카테고리 바텀시트 클릭',
  request_auto_open_category: '진료신청서 카테고리 바텀시트 자동 오픈',
  request_select_category: '진료신청서 카테고리 선택',
  request_page_in_quick_match: '진료신청서 퀵매치 진료신청 페이지 진입',
  request_open_load_detail_symptoms: '진료신청서 증상 불러오기 바텀시트 오픈',
  request_select_load_detail_symptom: '진료신청서 증상 불러오기 상세증상 선택',
  impressed_child_info_section: '진료신청서 아이 정보 섹션 노출',
};

export enum EWebDiagnosisInflowType {
  QnaDetail = 'qna_detail',
  MagazineDetail = 'magazine_detail',
  FaqDetail = 'faq_detail',
  HospitalDetail = 'hospital_detail',
  MedicineDictionaryDetail = 'medicine_dictionary_detail',
  NonBenefitMap = 'non_benefit_map',
  NonBenefitHome = 'non_benefit_home',
  DiseaseEncyclopediaDetail = 'disease_encyclopedia_detail',
}
